import { useState } from 'react';
import { Button, Typography } from '@/components';
import { SupportFeedbackModal, SupportFeedbackType } from '@/features/feedback-support';
import { useSupportFeedback } from '@/features/feedback-support/hooks';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '@/features/notifications';

export function AccountClosureDisclaimer() {
  const { t } = useTranslation(['settings']);
  const { add } = useNotifications();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<SupportFeedbackType>('support');

  const { submitFeedback } = useSupportFeedback({
    onSuccess: () => {
      add({
        id: new Date().toString(),
        title: t('Success'),
        description: t('Your message has been sent successfully'),
      });
    },
    onError: (error) => {
      add({
        id: new Date().toString(),
        title: t('Error'),
        description: t('Failed to send message. Please try again.'),
      });
      console.error('Support submission error:', error);
    },
  });

  const handleSupportClick = () => {
    setModalType('support');
    setModalOpen(true);
  };

  const handleSubmit = async (message: string, type: SupportFeedbackType) => {
    await submitFeedback(message, type);
  };

  return (
    <>
      <div className="space-y-6">
        <Typography as="h3" color="primary" size="title" weight="semibold">
          {t('Account management')}
        </Typography>
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          <span className="font-medium">Need to close your account?</span> Contact us via the{' '}
          <button
            onClick={handleSupportClick}
            type="button"
            className="font-sans font-medium underline underline-offset-2 transition-colors hover:cursor-pointer hover:text-amber-700"
          >
            Support button
          </button>{' '}
          or email us at{' '}
          <a
            href="mailto:nteaser@nteaser.com"
            className="font-medium underline underline-offset-2 transition-colors hover:text-amber-700"
          >
            clients@nteaser.com
          </a>
          {''}.
        </div>
      </div>

      <SupportFeedbackModal open={modalOpen} onOpenChange={setModalOpen} type={modalType} onSubmit={handleSubmit} />
    </>
  );
}
